import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import { useGetPayCheck } from "hooks/api";
import { usePostKakaopay } from "hooks/api";
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';

const Elem:React.FC<any> = () => {
  const { mutateAsync : postKakaoPay } = usePostKakaopay();
  const [ url, setUrl ] = useState("");
  const payCheckData = useGetPayCheck()
  const [ showModal, setShowModal ] = useState<boolean>(false);
  const navigator = useNavigate();
  
  const handleKakaoPayRegistration = async () => {
    const kakaoAuthResponse = await postKakaoPay();
    const redirectUrl = kakaoAuthResponse.data.next_redirect_mobile_url;
    return redirectUrl
  };


  const handleButtonClick = () => {
    navigator("/onboarding/3/credit");
  };
  const handleCloseModal = async () => {
    console.log('??herer??')
    setShowModal(false);
    setUrl('');
  };

  useEffect(() => {
    let timer:any;

    const fetchDataWithDelay = async () => {
      try {        
        const redirectUrl = await handleKakaoPayRegistration();  
        // newWindow = window.open(redirectUrl, "MyWindow");
        setUrl(redirectUrl);
        //팝업이 저상적으로 열림(팝업 차단이 해제됨)
        console.log("폴링을 백그라운드에서 수행 중...");
        console.log('????here1???')
        setShowModal(true);
        console.log('????here2???')
        timer = setInterval(async () => {
          console.log('????here3???')
        const updatedPayCheckData = await payCheckData.refetch();
        console.log('????here4???')
          if (updatedPayCheckData.data?.status === 200) {
            // 폴링 결과가 성공적으로 완료됨
            clearInterval(timer);
            console.log("폴링이 완료되었습니다.");
            await handleCloseModal()
            window.location.href="/onboarding/4/complete"
          } else {
            console.log('??? here?????', updatedPayCheckData)
          }
        }, 2000);
        } catch(error) {
          //에러처리
          console.log('error:', error)
        }
      };
    // 컴포넌트가 마운트되었을 때 초기 요청
    fetchDataWithDelay();

    //컴포넌트가 언마운트되면 타이머 해제
    return () => {
      clearTimeout(timer)
    }
  }, []);

  return (
  <>
    <div>
      {showModal &&(
        <KakaoPayModal
        isOpen={showModal}
        onRequestClose={handleCloseModal}
        contentLabel="URL Modal"
      >
      <URLframe 
        src={url}
        title="URL Frame"
        />
      </KakaoPayModal>
    )}
  </div>

  </>
  )
};

export default Elem;

const KakaoPayModal = styled(Modal)`
  width: 100%;
  height: 100%;
`
const URLframe = styled.iframe`
  width: 100%;
  height: 100%;
`